import script from "./danh-sach-dich-vu.vue?vue&type=script&setup=true&lang=js"
export * from "./danh-sach-dich-vu.vue?vue&type=script&setup=true&lang=js"

import "./danh-sach-dich-vu.vue?vue&type=style&index=0&id=1c27f11b&lang=scss&scoped=true"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c27f11b"]])

export default __exports__